<template>
  <div ui-view="" class="app-body" id="view">
    <div class="box mt-20" v-if="isEmployee || this.data.visitTypeCode == null">
      <div class="box-header">
        <!-- <h3>출입예정일 및 목적</h3> -->
        <h3 v-if="isEmployee">출입 IDC 및 방문 목적</h3>
        <h3 v-if="!isEmployee && this.data.visitTypeCode == null"> IDC 방문 목적</h3>
        <!-- <p>출입 기간과 방문 목적을 입력하세요.</p> -->
        <p v-if="isEmployee">출입 IDC 와 방문 목적을 선택하세요</p>
        <p v-if="!isEmployee && this.data.visitTypeCode == null">방문 목적을 선택하세요</p>
      </div>

      <div class="box-body pb-1" v-if="isEmployee">
          <div class="form-group row">
            <label class="col-2 form-control-label">
              <span class="ess">IDC</span>
            </label>
            <div class="col-10">
              <!--<label >-->
                <dropdown v-model="idcSelctedItem" :datasource="idcList"        title="" :isSelectionFirstData="false"  inline="inline" displayName="locationName" valueName="locationCode"   :width="220"/>
                <!--<dropdown v-model="searchTypeItem" :datasource="searchTypeList" title="" :isSelectionFirstData="false" inline="inline"/>-->
              <!--</label>-->
            </div>
          </div>
      </div>

      <div class="box-body pb-1">
          <div class="form-group row">
            <label class="col-2 form-control-label">
              <span class="ess">방문목적</span>
            </label>
            <div class="col-10">
              <label :class="['md-check', visitType.visitTypeCode == visitTypeCode? 'checked' : '', 'mt-5', 'mb-15']" v-for="(visitType, index) in visitTypeList" v-if="visitType.isEnable == 1" :key="index">
                <input type="radio" name="visitTypeCode" :checked="visitType.checked" v-model="visitTypeCode" :value="visitType.visitTypeCode">
                <i class="blue"></i>
                <div class="check-box ml-6">
                  <div class="check-tit ph-14 pv-9">{{visitType.visitTypeStr}}</div>
                  <ul class="p-10" style="text-align:center">
                    <i :class="visitTypeIcon(visitType.visitTypeCode)" style="font-size:45px"></i>
                  </ul>
                </div>
              </label>
            </div>
          </div>
      </div>
    </div>


    <div class="box mt-20">
      <div class="box-header">
        <!-- 방문요청 신청자 정보 입력 -->
        <h3>IDC 출입 체크리스트</h3>
        <!-- 이름, 연락처, 이메일주소 등 방문 신청자 정보를 입력하세요. -->
        <p>IDC 입실을 위해 아래 항목을 확인합니다.</p>
      </div>
    </div>

    <table class="tbl">
      <!--<colgroup><col width="16.66%"><col width="16.66%"><col width="16.66%"><col width="16.66%"><col width="16.66%"><col width="16.66%"></colgroup>-->
      <colgroup>
        <col width="60px">
        <col width="auto">
      </colgroup>
      <thead>
        <tr>
          <th></th>
          <th>CheckList</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(item, index) in checkItems" :key="index">
          <td>
            <label class="md-check">
              <input type="checkbox" v-model="item.checked">
              <i class="blue"></i>
            </label>
          </td>
          <td class="ellipsis">{{item.contents}}</td>
        </tr>
      </tbody>
    </table>

    <div class="btn-wrap mt-30 mb-30 justify-content-center">

      <button class="btn btn-lg line-2" @click="prev()" v-if="showPrev"><i class="icon-arrow-line-left mr-5"></i>이전</button>
      <button class="btn btn-lg blue" @click="next()" v-if="showNext" :disabled="isCheckNext">다음<i class="icon-arrow-line-right  ml-5"></i></button>
      <button class="btn btn-lg blue" @click="enter()" v-if="showEnter" :disabled="isCheckNext">확인<i class="icon-check  ml-5"></i></button>
    </div>
  </div>

</template>

<script>
import AgreeItem from '@/views/app/main/AgreeItem.vue';
import dropdown from "@/components/Dropdown.vue"
export default {
  components: {AgreeItem, dropdown},
  props: ['item', 'items', 'tos', 'data', 'isEmployee'],
  data(){
    return {
      idcList: null,
      idcSelctedItem:null,
      visitTypeCode: 1 ,
      visitTypeList: [],
      checkItems:[

      ]
    }
  },
  computed: {
    showEnter(){
      var index = _.findIndex(this.items, { 'id': this.item.id});
      return this.items.length-1 == index && this.isEmployee;
    },
    showPrev() {
      return this.item.id <= 1 ? false : true;
    },
    showNext(){

      if(this.showEnter)
        return false;
      return this.item.id <= this.items.length
    },
    isCheckNext() {
      if(this.idcSelctedItem && !this.showEnter)
        return false;
      if(!this.checkItems)
        return false;
      return this.checkItems.filter((item)=>{return item.checked}).length != this.checkItems.length;
    },
    visitStaus(){
      if(!this.checkItems)
        return false;
      return this.checkItems.filter((item)=>{return item.checked}).length != this.checkItems.length;
    },
    visitTypeIcon(){
      return (index)=>{
        var iconList = ['icon-setting', 'icon-prod-businessApplication', 'icon-warning', 'icon-publish']
        return iconList[index-1]

      }
    }
  },
  mounted(){

    this.loadItems();

  },
  methods: {
    enter(){

      if(this.isEmployee && this.idcSelctedItem == null){
        this.noti("입력 정보 확인", "출입 할 IDC를 선택해주세요.", 'warning');
        return ;
      }

      var that = this;
      var tos = this.tos.filter((x)=>x.isChecked).map((x)=>{return {tosIndex: Number(x.tosIndex), isAgree:x.isChecked ? 1: 0}})

      var o = {empEmail: this.data.empEmail, visitIdcCode: this.idcSelctedItem, visitTypeCode: this.visitTypeCode}

      this.$http.post('/api/private/emp/enter?' + jQuery.param(o), tos)
        .then((result) => {
          this.closeModal();
          // this.$toast.success("입실 확인되었습니다.")
          this.noti('완료', '입실 확인되었습니다.', 'success');
          this.$router.push('qrScan');
        }).catch((e) =>{

        })
    },
    prev(){
      this.$emit('changeStep', {item: this.item, action: -1})
    },
    next(){
      if(!this.data.visitTypeCode) this.$emit('changeStep', {item: this.item, tos: this.tos, checkList: this.checkItems, action: 1, visitTypeCode: this.visitTypeCode})
      else this.$emit('changeStep', {item: this.item, tos: this.tos, checkList: this.checkItems, action: 1})
    },
    getQuery(){
      var query = Object.assign({},this.$route.query);
      var tosList = this.checkItems.filter((item)=>{return item.isChecked});
            query.tos = JSON.stringify(_.chain(tosList)
      .keyBy('tosIndex')
      .mapValues('isChecked')
      .value());
      return query;
    },
    loadItems(){
      var that = this;
      this.$http.get('/api/public/checkList/2')
        .then((result) => {

          result.data.forEach((item) => {
            item.isChecked = false;
          });

          that.checkItems = result.data;
          // this.idcList = this.copyNew(this.$store.state.location.idcList);
          this.$http.get('/api/public/location/idcList')
            .then((result) => {
              that.idcList = result.data.filter((x)=> x.isDeleteYN == "N");
            }).catch((e) =>{
            console.log(e);
          })

        }).catch((e) =>{
      })
      this.visitTypeList = this.copyNew(this.$store.getters["dropdown/dataprovider"].visitType);

    },
    checkAllHandler(){
      this.checkItems.forEach((item)=>{
        item.isChecked = !item.isChecked ;
      })
    },
    agreeCheckHandler(data){
      var that = this;
      this.checkItems.forEach((item)=>{
        if(data.tosIndex == item.tosIndex) {
          item.isChecked = data.isChecked;
          return;
        }
      })
    }
  }
}
</script>

<style>

